<template>
  <Layout>
    <DsIslandsContainer>
      <DsIsland class="pb-spacing-400">
        <DsIllustration class="m-auto"
                        name="gold-child"
                        type="wide"></DsIllustration>
        <Advantages />
      </DsIsland>
      <DsIsland>
        <DsTitle size="h2">
          <span v-html="translate('goldkid-stepperAB:title')" />
        </DsTitle>
        <Steps />
      </DsIsland>
      <DsIsland radiusBottom="rounded">
        <DsTitle size="h2">
          <span v-html="translate('goldkid-conditions:title')" />
        </DsTitle>
        <Conditions />
      </DsIsland>
      <div class="mt-spacing-450">
        <snippet v-if="isGuideEnabled"
                 :lang="getLocalePlease"
                 :rounded="true"
                 :guide-link="true"
                 :title="translate('goldkid-FAQ:title')"
                 code="KaspiGoldForChild"
                 :contour="guideContour" />
      </div>
      <DsButtonBar sticky>
        <DsButton @click="startGoldKid"
                  size="large">
          {{ translate('goldkid-open-button:text') }}
        </DsButton>
        <template #description
                  v-if="!hasAgreement">
          <div @click="openAgreement">
            <span v-html="translate('goldkid-open:agreement')"></span>
          </div>
        </template>
      </DsButtonBar>
    </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import Advantages from './advantages.vue'
import Steps from './steps.vue'
import Conditions from './conditions.vue'
import useStore from '@/composables/useStore'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import authApi from '@/api/auth/authApi'
import translate from '@/filters/translate.filter'
import { getLocale } from '@/modules/locale/locale'
import { snippet } from "@guide/guide-snippet-vue2"
import "@guide/guide-snippet-vue2/styles"
import { DsIsland, DsIslandsContainer, DsTitle, DsButtonBar, DsButton, DsIllustration } from '@ds/vue2'
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue'
import useHeader from '@/composables/useHeader'
import Layout from '@/components/ui/Layout/Layout.vue'
import Cookies from 'js-cookie'
const store = useStore()
const { setTitle, showBackBtn, setBackFn, defaultBackNavigationFunction } = useHeader()
setBackFn(() => {
  defaultBackNavigationFunction()
})
const getLocalePlease = computed(() => {
  return getLocale() === 'ru-RU' ? 'ru' : 'kz'
})
const guideContour = process.env.VUE_APP_GUIDE_CONTOUR
const hasAgreement = ref(true)
showBackBtn()
setTitle(translate('title:goldkid'))
const clientsData = ref({
  firstName: '',
  lastName: '',
  middleName: '',
  iin: '',
  phoneNumber: ''
})
const isGuideEnabled = computed(() => {
  return store.getters['goldkidProcess/isGuideTipsEnabled']
})

const startGoldKid = function () {
  eventBus.$emit('kaspiLoading', true)
  const data = {
    meta: store.getters['goldkidProcess/meta'],
    data: {}
  }
  store.dispatch('goldkidProcess/processStep', data).then((response) => {
    if (response?.data?.object?.component === "systemError" || response?.data?.object?.component === "newYearUnavailable") {
      store.dispatch('goldkidProcess/setErrorText', response?.data?.object?.time)
      store.dispatch('goldkidProcess/component', response?.data?.object?.component)
    }
    else {
      store.dispatch('goldkidProcess/component', response?.data?.data?.component)
    }
    eventBus.$emit('kaspiLoading', false)
  })
}
const openAgreement = function () {
  store.dispatch('goldkidProcess/component', 'MainAgreement')
  sendAnalyticEvent('online_child_gold_collect_data_agreement', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
}


onMounted(() => {
  sendAnalyticEvent('online_child_gold_landing', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
  if (window.kaspi && typeof window.kaspi.send === 'function') {
    window.kaspi.send('closeSplashScreen')
  }
})

onBeforeMount(async () => {
  await store.dispatch('goldkidProcess/getUserProfile')
  store.dispatch('goldkidProcess/logEventToKafka', {
    ver: 1,
    usrId: store.getters['goldkidProcess/userData']?.userId,
    evt: 'gold_kid_events',
    act: 'online_child_gold_landing'
  })
  const data = {}
  const response = await authApi.isAuthorized()
  if (!response?.data?.data) {
    window.location = process.env.VUE_APP_BASE_URL + '/entrance'
  } else {
    store.dispatch('goldkidProcess/processStep', data).then((response) => {
      hasAgreement.value = response?.data?.data?.hasAgreement
      clientsData.value = response.data?.data?.clientsData
      store.commit('goldkidProcess/pId', store.getters['goldkidProcess/meta'].processId)
    })
  }
})

onBeforeUnmount(() => {
  sendAnalyticEvent('online_child_gold_landing', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['finish'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})
</script>
